import {mapActions, mapGetters, mapMutations} from 'vuex';
import item from './components/item/index.vue';
import HeadFilter from '@/components/features/head-filter/index.vue'
import BtnLoadMore from '@/components/atoms/buttons/load-more/index.vue'
import {seo} from '@/mixins/seo'

export default {
    name: 'shop',
    mixins: [seo],
    props: ['type'],
    data() {
        return {
            activeCategory: ''
        }
    },
    components: {
        item,
        HeadFilter,
        BtnLoadMore
    },
    computed: {
        ...mapGetters({
            listMy: 'shop/listMy',
            list: 'shop/list',
            skip: 'shop/skip',
            listLength: 'shop/listLength',
            isLoadingList: 'shop/isLoadingList',

            isLoadingCategories: 'courses/isLoadingCategories',
        }),

        hasTypeModule() {
            return this.type === 'module'
        },

        hasLoadSHop() {
            if (!this.hasTypeModule) return true;
            return this.list.length
        }
    },
    created() {
        this.fetchList();
        this.fetchMyList();

        this.seo.title = this.$t('shop')
    },
    methods: {
        ...mapActions({
            fetchList: 'shop/GET_LIST',
            fetchMyList: 'shop/GET_MY_LIST',
        }),
        ...mapMutations({
            changeCategory: 'shop/CHANGE_CATEGORY'
        })
    },
    destroyed() {
        this.changeCategory('')
    }
}
